import { Employee } from './Employee';

export class PodShuffleEmployeeForecast {
  id: number;

  podId: number;

  role: string;

  employee: Pick<Employee, 'id' | 'firstName' | 'lastName' | 'fullName'>;

  maxMembers: number;

  allocatedMembers: number;

  constructor(obj: any) {
    this.id = obj.id;
    this.podId = obj.podId;
    this.role = obj.role;
    this.employee = new Employee(obj.employee);
    this.maxMembers = obj.maxMembers;
    this.allocatedMembers = obj.allocatedMembers;
  }
}

export default PodShuffleEmployeeForecast;
